import React from 'react';
import * as PropTypes from 'prop-types';
import { connect, getIn } from 'formik';

import FormHelperText from '~/components/core/Atomic/FormHelperText';
import { reportErrorInProductionOrThrow } from '~/Utils';

import { shouldShowFieldError } from './formikErrorUtils';

const ErrorHelperTextFormik = connect((props) => {
  const { formik, id, withoutChildren, className, style } = props;

  // Rendered outside a Formik provider `formik` is undefined. That is always a caller bug, so
  // report it rather than fail silently: Sentry in prod/UAT, a loud throw in dev/staging. Where
  // it only reports, rendering nothing keeps the page up instead of a TypeError killing it.
  if (!formik) {
    reportErrorInProductionOrThrow(`ErrorHelperTextFormik rendered outside a Formik provider (id: ${id})`);
    return null;
  }

  const { errors, touched, submitCount } = formik;
  const showError = shouldShowFieldError(id, touched, submitCount);

  let errorMsg = getIn(errors, id);
  const isErrorOfChildrenOnly = errorMsg && typeof errorMsg !== 'string';

  if (isErrorOfChildrenOnly) {
    // we probably have a nested validation and error is an array of error messages
    errorMsg = JSON.stringify(errorMsg);
  }

  if (!(getIn(errors, id) && showError)) {
    return null;
  }

  if ((isErrorOfChildrenOnly && !withoutChildren) || !isErrorOfChildrenOnly) {
    return (
      <FormHelperText className={className} style={style} error>
        {errorMsg}
      </FormHelperText>
    );
  }

  return <></>;
});

ErrorHelperTextFormik.propTypes = {
  id: PropTypes.string.isRequired,
  withoutChildren: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};
export { ErrorHelperTextFormik };
